$ = jQuery;

class Courses {
	constructor(){
		// Get elements
		this.getElements();

		// Map courses
		this.mapCourses();

		// Listen changes to the filter checkboxes
		this.listenFilters();

		// Allow only one click on each register button
		this.allowOnlyOneClickOnRegisterButtons();
	}

	getElements(){
		this.$elements = {
			filters: {
				statuses:   $( '.uo-lfm-my-account-courses-filter input[name="status"]' ),
				categories: $( '.uo-lfm-my-account-courses-filter input[name="category"]' ),
			},
			searchField:    $( '#uo-lfm-my-account-courses-search' ),
			courses:        $( '.ultp-dashboard-course' ),
			registerButtons: $( '.ultp-dashboard-course__action--register a' )
		}
	}

	mapCourses(){
		this.courses = this.$elements.courses.map( ( i, course ) => {
			let $course = $( course );

			// Get the course categories
			let categories = $course.data( 'categories' );

			// Check if it's not an array (it might happen if it's only one element)
			if ( ! $.isArray( categories ) ){
				categories = [ categories ];
			}

			// Get status
			let status = $course.data( 'status' );

			return {
				$element:   $course,
				status:     status == 'not_enrolled' || status == 'not-enrolled' ? 'not-enrolled' : 'enrolled',
				searchName: $course.data( 'search-title' ),
				categories: categories,
			}
		} ).toArray()
	}

	listenFilters(){
		this.$elements.filters.statuses.on( 'change', () => {
			this.filter();
		});

		this.$elements.filters.categories.on( 'change', () => {
			this.filter();
		});

		this.$elements.searchField.on( 'input', () => {
			this.filter();
		});
	}

	filterByStatus( statuses = [], courses ){
		if ( statuses.length > 0 ){
			courses = courses.filter( ( course ) => {
				return statuses.includes( course.status );
			} );
		}

		return courses;
	}

	filterByCategories( categories = [], courses ){
		if ( categories.length > 0 ){
			courses = courses.filter( ( course ) => {
				return course.categories.some( category => categories.includes( category ) );
			});
		}

		return courses;
	}

	filterByName( name = '', courses ){
		if ( name != '' ){
			courses = courses.filter( ( course ) => {
				return course.searchName.includes( name )
			} );
		}

		return courses;
	}

	filter(){
		// Get all courses
		let courses = this.courses;

		// Get current filters
		const currentFilters = this.getCurrentFilters();

		// Hide all courses
		this.hideAll();

		// Filter statuses
		courses = this.filterByStatus( currentFilters.statuses, courses );

		// Filter categories
		courses = this.filterByCategories( currentFilters.categories, courses );

		// Filter by search
		courses = this.filterByName( currentFilters.search, courses );

		this.showCourses( courses );
	}

	showCourses( courses ){
		// Show the results
		courses.forEach(( course ) => {
			course.$element.show(); 
		});
	}

	getCurrentFilters(){
		return {
			statuses:   this.$elements.filters.statuses
							.filter( ':checked' )
							.map(( index, filter ) => {
								return filter.value;
							}).toArray(),

			categories: this.$elements.filters.categories
							.filter( ':checked' )
							.map(( index, filter ) => {
								return filter.value;
							}).toArray(),

			search:     this.$elements.searchField.val()
							.trim()
							.replace( ' ', '' )
							.toLowerCase()
		}
	}

	allowOnlyOneClickOnRegisterButtons(){
		// Listen clicks on the register buttons
		this.$elements.registerButtons.on( 'click', ( event ) => {
			// Get the clicked button
			const $button = $( event.currentTarget );

			// Add a loading class
			$button
				.addClass( 'ultp-dashboard-btn--loading' );
		});
	}

	hideAll(){
		this.$elements.courses.hide();
	}

	showAll(){
		this.$elements.courses.show();
	}
}

export default Courses;